import { css, html, TemplateResult } from 'lit';
import { MobxLitElement } from '@adobe/lit-mobx';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../styles/shared-styles';
import { playbackStore } from '../stores/playbackStore';
import { libraryStore } from '../stores/libraryStore';
import './album-card';

@customElement('app-content')
export class AppContent extends MobxLitElement {
    @property({ type: Boolean }) isDraggedOver = false;

    private FilePickerKey = "FilePicker"

    static styles = [styles, css`
    :host {

    }

    @media(prefers-color-scheme: light) {
      :host {
      }
    }

    @media(prefers-color-scheme: dark) {
      :host {
      }
    }

    #root {
        height: 100%;
        overflow-x: auto;
        background: var(--bg-color);
    }

    .album-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 0;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        text-align: center;
        color: var(--text-color-secondary, #666);
    }

    .empty-state h2 {
        margin: 0 0 16px 0;
        font-size: 24px;
        font-weight: 300;
    }

    .empty-state p {
        margin: 0 0 24px 0;
        font-size: 14px;
        max-width: 400px;
        line-height: 1.5;
    }

    .file-input-section {
        margin-bottom: 20px;
        padding: 20px;
        border: 2px dashed var(--border-color, #ddd);
        border-radius: 8px;
        text-align: center;
        background: var(--card-bg-color, #fafafa);
    }

    .file-input-section h3 {
        margin: 0 0 12px 0;
        color: var(--text-color, #333);
    }

    .file-input-section p {
        margin: 0 0 16px 0;
        color: var(--text-color-secondary, #666);
        font-size: 14px;
    }

    // input[type="file"] {
    //     display: none;
    // }
  `];

    render(): TemplateResult {
        // console.log(`app-content render ${Date.now()}`);

        const albums = libraryStore.getAlbumsGrouped();
        const hasLibrary = libraryStore.musicFiles.length > 0;

        return html`
<div id="root">
    ${!hasLibrary ? html`
        <div class="empty-state">
            <h2>Welcome to Playa</h2>
            <p>Select a music folder from the sidebar to get started, or try playing a single MP3 file below.</p>

            <div class="file-input-section">
                <h3>Quick Test</h3>
                <p>Select an MP3 file to play immediately:</p>
                <input
                    title="mp3 file picker"
                    type="file"
                    accept=".mp3"
                    @change="${this.onMp3PickerChanged}"
                />
            </div>
        </div>
    ` : html`
        <div class="album-grid">
            ${albums.map(album => html`
                <album-card
                    .artist="${album.artist}"
                    .album="${album.album}"
                    .year="${album.year}"
                    .files="${album.files}"
                    .albumArt="${album.albumArt}"
                    .albumArtFile="${album.albumArtFile}"
                ></album-card>
            `)}
        </div>
    `}

    <div @onDrop="${this.dropHandler}" @onDragOver="${this.dragOverHandler}" @onDragEnter="${this.dragEnterHandler}" @onDragLeave="${this.dragLeaveHandler}">
        <!--
        <p>Add your music folder to get started</p>
        <input title="file picker" type="file" id="${this.FilePickerKey}" @onChange="${this.onFilePickerChanged}" webkitdirectory></input>
        <button @click="${this.openFilePicker}">browse...</button>

        <h1>Directory File picker:</h1>
        <input title="directory picker" type="file" id="FileUpload" @change="${this.selectFolder}" webkitdirectory mozdirectory msdirectory odirectory directory multiple />
        -->
    </div>
</div>
    `;
    }

    private onMp3PickerChanged(e: Event) {
        var files = (e.target as HTMLInputElement).files;

        if (files && files[0]) {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                const mp3Uri = reader.result as string

                playbackStore.setTrackUri(mp3Uri);
                playbackStore.play();
            });
            reader.readAsDataURL(files[0]);
        }
    }

    private openFilePicker(_e: Event) {
        this.shadowRoot?.getElementById(this.FilePickerKey)!.click();
    }

    private selectFolder(e: Event) {
        var theFiles = (e.target as HTMLInputElement).files;
        if (theFiles) {
            var relativePath = theFiles[0].webkitRelativePath;
            var folder = relativePath.split("/");
            alert(folder[0]);
        }
    }

    private onFilePickerChanged() {
        const file = (document.getElementById(this.FilePickerKey) as HTMLInputElement)?.files;
        if (file) {
            const fileItem = file.item(0);
            if (fileItem) {
                const reader = new FileReader();
                reader.addEventListener('load', () => {
                    // console.log(`@@@ TODO: set result in state: ${reader.result as string}`)
                    //setSrc(reader.result as string);
                });
                reader.readAsDataURL(fileItem);
            }
        }
    }

    private dragOverHandler(e: DragEvent) {
        e.preventDefault();
    }

    private dragEnterHandler() {
        this.isDraggedOver = true;
    }

    private dragLeaveHandler() {
        this.isDraggedOver = false;
    }

    private dropHandler(e: DragEvent) {
        // Prevent default behavior (Prevent file from being opened)
        e.preventDefault();

        if (e.dataTransfer?.items) {
            // Use DataTransferItemList interface to access the file(s)
            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                const item = e.dataTransfer.items[i];
                if (item.kind === "file") {
                    const reader = new FileReader();
                    reader.addEventListener('load', () => {
                        // TODO: implement file URI handling
                        // const fileUri = reader.result as string;
                        // console.log(`@@@ TODO: set result in state: ${fileUri}`)

                    });
                    reader.readAsDataURL(item.getAsFile()!);
                    break;
                }
            }
        }
    }
}
